import React from 'react'
import './style.css'
import { NavLink, useNavigate } from 'react-router-dom'
import { handleLogout } from '../../redux/slices/authSlice'
import { useDispatch, useSelector } from 'react-redux'

const CorporateSIdebar = () => {

    const dispatch = useDispatch();
    const user = useSelector(state => state?.AuthSlice?.user)
    const isDisabled = user?.subscription?.status !== 'active' && user?.subscription?.status !== 'cancelled';
    const navigate = useNavigate()

    const handleLogoutHere = async () => {
        const res = await dispatch(handleLogout())
        navigate("/signin");
    }

    return (
        <>
            <ul className="corporate-sidebar">
                {/* <li>
                    <input type="search" className='sidebar-input' placeholder='Search' />
                </li> */}

                <li>
                    <NavLink to="/corporate/dashboard" className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : isDisabled
                                ? 'disable-btn'
                                : ''
                    }><i className="fa-solid fa-boxes-stacked"></i> Dashboard</NavLink>
                </li>

                <li>
                    <NavLink to='/corporate/employees' className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : isDisabled
                                ? 'disable-btn'
                                : ''
                    }><i className="fas fa-share-alt"></i> My Employees</NavLink>
                </li>

                <li>
                    <NavLink to='/corporate/subscriptions' className={({ isActive }) => isActive ? 'active-link' : ''}><i className="fas fa-crown"></i> Subscription</NavLink>
                </li>

                <li>
                    <NavLink to='/corporate/profile' className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : isDisabled
                                ? 'disable-btn'
                                : ''
                    }><i className="fa-solid fa-user"></i> My Profile</NavLink>
                </li>

                <li>
                    <NavLink to='/corporate/notifications' className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : isDisabled
                                ? 'disable-btn'
                                : ''
                    }><i className="fa-regular fa-bell"></i> Notifications</NavLink>
                </li>

                <li>
                    <NavLink to='/corporate/settings' className={({ isActive }) =>
                        isActive
                            ? 'active-link'
                            : isDisabled
                                ? 'disable-btn'
                                : ''
                    }><i className="fa-solid fa-gear"></i> Settings</NavLink>
                </li>

                <li>
                    <NavLink style={{ cursor: 'pointer' }} onClick={handleLogoutHere}><i className="fa-solid fa-right-from-bracket"></i> Logout</NavLink>
                </li>
            </ul>
        </>
    )
}

export default CorporateSIdebar